import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import LocalStitchMap from 'components/common/LocalStitchMap';

var ModalMapPopup = function ModalMapPopup(_ref) {
  var closeModal = _ref.closeModal,
      branch = _ref.branch;
  var mapCenter = {
    lat: Number(branch.latitude),
    lng: Number(branch.longitude)
  };
  return /*#__PURE__*/_jsx("div", {
    className: "dimd-layer",
    children: /*#__PURE__*/_jsx("div", {
      className: "inner n-pad",
      children: /*#__PURE__*/_jsxs("section", {
        className: "pop-spot",
        children: [/*#__PURE__*/_jsx(LocalStitchMap, {
          center: mapCenter,
          branches: [branch],
          zoom: 16
        }), /*#__PURE__*/_jsx("div", {
          className: "map-w",
          style: {
            marginTop: 0,
            paddingBottom: 30
          }
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "btn-close",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx("span", {
            children: "\uD31D\uC5C5 \uB2EB\uAE30"
          })
        })]
      })
    })
  });
};

export default ModalMapPopup;